import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import useStores from "stores";
import { loginUrl, logoutUrl } from "utils/api/ajax";

import style from "./index.module.scss";

const App = observer((props) => {
  const { headerStore, loginStore } = useStores();
  let { contentWidth, bgColor } = props;
  let [curTab, setCurTab] = useState(loginStore.isLogin ? 0 : 1);
  // let [loginUrl, setLoginUrl] = useState("/startPage"); //eslint-disable-line
  let [notifyState, setNotifyState] = useState("none");
  let [loginState, setLoginState] = useState("none");

  const handleNotify = () => {
    if (notifyState === "none" && headerStore.notifyCount !== 0) {
      headerStore.unReadNotifyCount();
      //重新调用消息接口
      headerStore.pageQueryMsg({
        pageIndex: 1,
        pageSize: 6,
      });
      //调用已读消息接口
      headerStore.switchReadState();
    }
    setNotifyState(notifyState === "none" ? "block" : "none");
  };
  const handleLogin = () => {
    setLoginState(loginState === "none" ? "block" : "none");
  };
  useEffect(() => {
    if (!loginStore.isLogin) {
      loginStore.getUserInfo(); // 获取用户信息
    }
    if (loginStore.isLogin) {
      //消息通知
      headerStore.unReadNotifyCount();
      headerStore.pageQueryMsg({
        pageIndex: 1,
        pageSize: 6,
      });
    }
    headerStore.queryNotice({
      pageIndex: 1,
      pageSize: 6,
    });
    //点击切换隐藏/显示
    document.addEventListener("click", () => {
      setNotifyState("none");
      setLoginState("none");
    });

    setCurTab(loginStore.isLogin ? 0 : 1);
  }, [loginStore.isLogin]); //eslint-disable-line
  return (
    <div
      className={`${style.app} ${style.appContaner} ${props.flow ? style.flow : ''}`}
      style={{ background: bgColor }}
    >
      <div className={`${style.header}`} style={{ width: contentWidth }}>
        <div className={`${style.left}`}>
          <div className={`${style.logo}`}>
            <a href={`/`}>
              <img
                src="https://img14.360buyimg.com/imagetools/jfs/t1/132290/20/11897/2611/5f7ffc6bE6d622634/2e8dcd84cd96ccfc.png"
                alt=""
                clstag="pageclick|keycount|VopOpenIndex_1602911919488|10"
              />
            </a>
          </div>
        </div>
        <div className={`${style.center}`}>{props.children}</div>
        <div className={`${style.right}`}>
          <div className={`${style.tip}`}>
            {headerStore.notifyCount > 0 ? (
              <span className={`${style.num}`}>{headerStore.notifyCount}</span>
            ) : (
              ""
            )}
            <img
              src="https://img12.360buyimg.com/imagetools/jfs/t1/114015/2/19521/593/5f80072dE4571c5ae/b339e0ed0e19a2cc.png"
              alt=""
              onClick={(e) => {
                e.nativeEvent.stopImmediatePropagation();
                handleNotify();
              }}
              clstag="pageclick|keycount|VopOpenIndex_1602911919488|18"
            />
            <div
              className={`${style.notifyContainer}`}
              style={{ display: notifyState }}
              onClick={(e) => {
                e.nativeEvent.stopImmediatePropagation();
              }}
            >
              <div className={`${style.tabPanel}`}>
                {loginStore.isLogin && (
                  <div
                    className={`${style.panelItem} ${
                      curTab === 0 ? style.cur : ""
                    }`}
                    onClick={() => {
                      setCurTab(0);
                    }}
                  >
                    消息通知
                  </div>
                )}
                <div
                  className={`${style.panelItem} ${
                    curTab === 1 ? style.cur : ""
                  }`}
                  onClick={() => {
                    setCurTab(1);
                  }}
                >
                  系统公告
                </div>
              </div>
              {curTab === 0 ? (
                <div className={`${style.tabContent}`}>
                  {headerStore.notifyList.length
                    ? headerStore.notifyList.slice(0, 6).map((item) => (
                        <div
                          className={`${style.contentItem}`}
                          key={item.notifyId}
                        >
                          <span className={`${style.title}`}>
                            {item.readStateType === 0 ? <i></i> : ""}
                            <span className={`${style.text}`}>
                              {item.notifyContent}
                            </span>
                          </span>
                          <span className={`${style.time}`}>
                            {item.updateTime.split(/\s+/g)[0]}
                          </span>
                        </div>
                      ))
                    : <div className={`${style.notips}`}>暂无消息</div>}
                  {headerStore.notifyList.length ? (
                    <div className={`${style.contentMore}`}>
                      <a href="/message" target="_blank" clstag="pageclick|keycount|VopOpenIndex_1602911919488|20">
                        查看全部
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div className={`${style.tabContent}`}>
                  {headerStore.noticeList.length
                    ? headerStore.noticeList.slice(0, 6).map((item) => (
                        <Link
                          className={`${style.contentItem} ${style.itemhover}`}
                          key={item.noticeId}
                          to={`/notice/${item.noticeId}`}
                          // onClick={() => {
                          //   location.href = `/notice/${item.noticeId}`;
                          // }}
                        >
                          <span className={`${style.title}`}>
                            <span className={`${style.text}`}>
                              {item.noticeTitle}
                            </span>
                          </span>
                          <span className={`${style.time}`}>
                            {item.updateTime.split(/\s+/g)[0]}
                          </span>
                        </Link>
                      ))
                    : ""}
                  <div className={`${style.contentMore}`}>
                    <Link to="/notice" clstag="pageclick|keycount|VopOpenIndex_1602911919488|19">查看全部</Link>
                  </div>
                </div>
              )}
            </div>
          </div>
          {loginStore.user && loginStore.user.pin ? (
            <div
              className={`${style.logined}`}
              onClick={(e) => {
                e.nativeEvent.stopImmediatePropagation();
                handleLogin();
              }}
            >
              <div className={`${style.avatar}`}>
                <img
                  src="https://img13.360buyimg.com/imagetools/jfs/t1/140360/22/15920/374115/5fbf9bbdEf40b38de/4f752f8bad1552c6.png"
                  alt=""
                />
              </div>
              <div className={`${style.name}`}>{loginStore.userName}</div>
              <div className={`${style.arrow}`}></div>
              <div
                className={`${style.userContainer}`}
                style={{ display: loginState }}
              >
                <Link
                  className={`${style.bottom} ${style.psd}`}
                  to="/passport/editpsd"
                  clstag="pageclick|keycount|VopOpenIndex_1602911919488|34"
                >
                  <div className={`${style.loginout}`}>
                    <span className={`${style.logoutText}`} >
                      修改密码
                    </span>
                    <span
                      className={`${style.imgBox}`}
                    >
                      <img
                        src="https://img14.360buyimg.com/imagetools/jfs/t1/161367/37/26148/1193/619dabb5E4923d68e/c4a6db4d3a740ef8.png"
                        alt=""
                      />
                    </span>
                  </div>
                </Link>
                <div className={`${style.bottom}`}>
                  <div className={`${style.loginout}`}>
                    <a className={`${style.logoutText}`} href={logoutUrl}>
                      退出账号
                    </a>
                    <a
                      className={`${style.imgBox}`}
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <img
                        src="https://img11.360buyimg.com/imagetools/jfs/t1/138973/33/24437/1195/619daebaE4334edcd/d95f56ae523a432c.png"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={`${style.unlogin}`}>
              <div className={`${style.login}`}>
                <Link to={loginUrl} clstag="pageclick|keycount|VopOpenIndex_1602911919488|21">登录</Link>
              </div>
              <div className={`${style.register}`} clstag="pageclick|keycount|VopOpenIndex_1602911919488|22">
                <a href="http://reg.jd.com/e/common/regPage?source=bvop_pc&ReturnUrl=https://vop.jd.com/passport/middle">
                  注册
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default App;
